import React from "react";
import PreLoaderWidget from '../../../components/Loader';
import CardExames from "./components/CardExames";

const ContExames = ({interacao, solicitacaoExames, paciente, preloadSolicExame, profissionais}) => {

    return(
      <>
        <div className="p-2">
    
            {preloadSolicExame ? (<PreLoaderWidget />) :
                solicitacaoExames.map((item, index) => {
                return (
                    <CardExames
                        card={"solicitacao_exame"}
                        interacao={interacao}
                        paciente={paciente}
                        Hora={item.Hora ? item.Hora : null}
                        item={item}
                        DataCriacao={item.DataCriacao}
                        profissional={profissionais.find(x => x.id === item.refProfissional.id).nome}
                    />);
                })
            }
        </div>
      </>
    )
}

export default ContExames;